import firebase from "firebase/compat/app";
import { FC, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { createRef } from "../../../db/connection";
import { getListByClient } from "../../../db/serviceWABA";
import * as lc from "../../modules/localstorage";
import { realtimedb } from "../../../db";

const realtimeDB = realtimedb;

const updateBalance = async (accountID: string, amount: number) => {
  const existingData = await realtimeDB
    .ref("account/" + accountID)
    .get()
    .then((snap) => (snap.exists() ? snap.val() : undefined));
  if (existingData && existingData.balance) {
    realtimeDB.ref("account/" + accountID + "/balance").transaction((data) => {
      return data + amount;
    });
  } else {
    realtimeDB.ref("account/" + accountID + "/balance").set(amount);
  }
};

function RealtimeDBAccount() {
  const clientID = lc.getItemLC(lc.LCName.Client).id;
  const { data: accounts } = useQuery([`waba-account`, clientID], () =>
    getListByClient(createRef("clients", clientID))
  );
  const [selectedAccount, setSelectedAccount] = useState<string>("");

  const [count, setCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [balance, setBalance] = useState<number>(0);
  const [balanceInput, setBalanceInput] = useState<string>("");
  const [lastNotes, setLastNotes] = useState<string[]>([]);

  const handleTopUp = async (accountID: string, topUpAmount: any) => {
    console.log(topUpAmount);
    if (isLoading) return;
    setIsLoading(true);
    await updateBalance(accountID, topUpAmount);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!selectedAccount || selectedAccount === "") {
      setCount(0);
      setBalance(0);
      setBalanceInput("");
      return;
    }
    const handleDataChange = (snap: firebase.database.DataSnapshot) => {
      setIsLoading(true);
      const data = snap.val();
      if (data && data.count) {
        setCount(data.count);
      } else {
        setCount(0);
      }
      if (data && data.balance) {
        setBalance(data.balance);
      } else {
        setBalance(0);
      }
      if (data && data.note) {
        setLastNotes(data.note);
      } else {
        setLastNotes(["NO NOTES YET"]);
      }
      setIsLoading(false);
    };

    realtimeDB.ref("account/" + selectedAccount).on("value", handleDataChange);
    return () => {
      realtimeDB
        .ref("account/" + selectedAccount)
        .off("value", handleDataChange);
    };
  }, [selectedAccount]);

  if (!accounts) {
    return <div>Loading...</div>;
  }

  return (
    <div className="d-flex align-items-start" style={{ gap: "1rem" }}>
      <div>
        <select
          value={selectedAccount}
          onChange={(e) => setSelectedAccount(e.target.value)}
          className="form-select"
          name="account"
          id="account"
        >
          <option value="">Select Account</option>
          {accounts.map((account) => (
            <option key={account.id} value={account.id}>
              {account.businessName ?? account.id}
            </option>
          ))}
        </select>
        <p className="mt-3 px-4 fs-1">
          Count:
          {isLoading ? (
            <span className="fs-6">Processing...</span>
          ) : (
            <span className="fw-bolder">{count}</span>
          )}
        </p>
      </div>
      <div>
        <p className="mt-3 px-4 fs-1">
          Balance:
          {isLoading ? (
            <span className="fs-6">Processing...</span>
          ) : (
            <span className="fw-bolder">{balance}</span>
          )}
        </p>
        <div className="mt-3 px-4">
          <input
            type="number"
            value={balanceInput}
            onChange={(e) => setBalanceInput(e.target.value)}
            className="form-control"
            placeholder="Enter balance amount"
          />
          <button
            onClick={async () =>
              await handleTopUp(selectedAccount, parseFloat(balanceInput))
            }
            type="button"
            disabled={
              selectedAccount === "" || balanceInput === "" || isLoading
            }
            className="btn btn-primary mt-2"
          >
            Update Balance
          </button>
        </div>
      </div>
    </div>
  );
}

const RealtimeDBTab: FC = () => {
  return <RealtimeDBAccount />;
};

export default RealtimeDBTab;
